import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaClock, FaSignal } from 'react-icons/fa';

const AsanaModal = ({ asana, isOpen, onClose }) => {
  if (!asana) return null;

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Beginner': return '#4CAF50';
      case 'Intermediate': return '#FF9800';
      case 'Advanced': return '#F44336';
      default: return '#667eea';
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '2rem'
          }}
        >
          <motion.div
            className="modal-content"
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.7, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white',
              borderRadius: '20px',
              padding: '2rem',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative'
            }}
          >
            <button
              onClick={onClose}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              <FaTimes />
            </button>

            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={{
                width: '100%',
                height: '300px',
                borderRadius: '15px',
                overflow: 'hidden',
                marginBottom: '1rem',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
              }}>
                <img 
                  src={asana.image || asana.icon} 
                  alt={asana.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div style={{
                  display: 'none',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'linear-gradient(45deg, #667eea, #764ba2)',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '4rem',
                  color: 'white'
                }}>
                  {asana.icon || '🧘‍♀️'}
                </div>
              </div>
              <h2 style={{ margin: '0.5rem 0', color: '#333' }}>{asana.name}</h2>
              <p style={{ fontStyle: 'italic', color: '#667eea', fontSize: '1.2rem' }}>
                {asana.sanskrit}
              </p>
              
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '2rem',
                marginTop: '1rem',
                flexWrap: 'wrap'
              }}>
                {asana.difficulty && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <FaSignal style={{ color: getDifficultyColor(asana.difficulty) }} />
                    <span style={{ color: getDifficultyColor(asana.difficulty), fontWeight: 'bold' }}>
                      {asana.difficulty}
                    </span>
                  </div>
                )}
                {asana.duration && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <FaClock style={{ color: '#667eea' }} />
                    <span style={{ color: '#667eea' }}>{asana.duration}</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ color: '#333', marginBottom: '1rem' }}>🌟 Benefits</h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {asana.benefits.map((benefit, index) => (
                  <li key={index} style={{
                    marginBottom: '0.8rem',
                    paddingLeft: '1.5rem',
                    position: 'relative',
                    lineHeight: 1.6
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: '#4CAF50',
                      fontWeight: 'bold'
                    }}>✓</span>
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>

            {asana.steps && (
              <div>
                <h3 style={{ color: '#333', marginBottom: '1rem' }}>📝 How to Practice</h3>
                <ol style={{ paddingLeft: '1rem' }}>
                  {asana.steps.map((step, index) => (
                    <li key={index} style={{
                      marginBottom: '0.8rem',
                      lineHeight: 1.6,
                      color: '#555'
                    }}>
                      {step}
                    </li>
                  ))}
                </ol>
              </div>
            )}

            <div style={{
              marginTop: '2rem',
              padding: '1rem',
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              borderRadius: '10px',
              color: 'white',
              textAlign: 'center'
            }}>
              <p style={{ margin: 0, fontStyle: 'italic' }}>
                "Remember to breathe deeply and listen to your body. Never force a pose."
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AsanaModal;
